import { render, staticRenderFns } from "./BtnComprobantesPendientes.vue?vue&type=template&id=2c4e9300"
import script from "./BtnComprobantesPendientes.vue?vue&type=script&lang=js"
export * from "./BtnComprobantesPendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports